import { Injectable, TemplateRef } from '@angular/core';
import { Toast, ToastOptions } from '@shared/interfaces/toasts.interface';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private static readonly MAX_VISIBLE_TOASTS = 3;

  toasts: Toast[] = [];

  showStandard(text: string, header = '', options: ToastOptions = {}): void {
    this.show(text, header, options);
  }

  showSuccess(
    text: string,
    header = '',
    delayOrOptions: number | ToastOptions = 5000,
    options: ToastOptions = {}
  ): void {
    this.show(text, header, {
      ...this.normalizeOptions(delayOrOptions, options),
      classname: 'jip-success',
    });
  }

  showError(
    text: string,
    header = '',
    delayOrOptions: number | ToastOptions = 10000,
    options: ToastOptions = {}
  ): void {
    this.show(text, header, {
      ...this.normalizeOptions(delayOrOptions, options),
      classname: 'jip-error',
    });
  }

  private show(
    textOrTpl: string | TemplateRef<unknown>,
    header = '',
    options: ToastOptions = {}
  ): void {
    this.toasts.push({ textOrTpl, header, ...options });

    if (this.toasts.length > ToastService.MAX_VISIBLE_TOASTS) {
      this.toasts.splice(
        0,
        this.toasts.length - ToastService.MAX_VISIBLE_TOASTS
      );
    }
  }

  private normalizeOptions(
    delayOrOptions: number | ToastOptions,
    options: ToastOptions
  ): ToastOptions {
    return typeof delayOrOptions === 'number'
      ? { ...options, delay: delayOrOptions }
      : delayOrOptions;
  }

  remove(toast: unknown): void {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  removeAll(): void {
    this.toasts = [];
  }
}
